import { useFeatureFlag } from '@artic/ui/feature-flag';
import { FullHeightStack } from '@artic/ui/full-height-layout';
import { createFileRoute } from '@tanstack/react-router';
import { useQueryState } from 'nuqs';

import { DriveWatchPanel } from '../../features/imports/drive-watch-panel';
import { ImportsListTable } from '../../features/imports/imports-list-table';
import { importsSearchParsers, type ImportStatus } from '../../features/imports/search';
import { usePartnerId } from '../../features/inbox/use-partner-name';

export const Route = createFileRoute('/imports/')({
  staticData: {
    breadcrumb: 'Imports',
    layout: 'default',
  },
  component: ImportsPage,
});

function ImportsPage() {
  const enabled = useFeatureFlag('imports');
  const partnerId = usePartnerId();
  const [status, setStatus] = useQueryState('status', importsSearchParsers.status);

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Imports is not available</h2>
        <p className="text-muted-foreground text-sm">
          Imports is not enabled for your organisation.
        </p>
      </div>
    );
  }

  return (
    <FullHeightStack className="gap-3">
      <header className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold">Imports</h1>
          <p className="text-muted-foreground text-sm">
            Spreadsheet imports of work orders — uploaded via the planner or picked up automatically
            from Google Drive.
          </p>
        </div>
        <label className="flex items-center gap-2 text-sm">
          <span className="text-muted-foreground">Status</span>
          <select
            className="border-input h-8 rounded-md border bg-transparent px-2 text-sm shadow-sm"
            value={status ?? ''}
            onChange={(e) => {
              const next = e.target.value;
              void setStatus(next === '' ? null : (next as ImportStatus));
            }}
          >
            <option value="">All</option>
            <option value="pending">Pending</option>
            <option value="in_progress">In progress</option>
            <option value="success">Success</option>
            <option value="error">Error</option>
          </select>
        </label>
      </header>
      <DriveWatchPanel partnerId={partnerId} />
      <div className="min-h-0 flex-1 overflow-y-auto">
        <ImportsListTable partnerId={partnerId} {...(status ? { status } : {})} />
      </div>
    </FullHeightStack>
  );
}
